<a *ngIf="(brand | brandLink | async) as productBrand; else noBrandLink"
   [routerLink]="[productBrand.linksTo?.url]"
   class="brand-link"
>
    {{ brand?.text }}
</a>
<ng-template #noBrandLink>
    {{ brand?.text }}
</ng-template>
